/** @see go/agent_roster */
export const CHAT_AGENT_TITLE = 'AI Chat'
export const SUPERHUMAN_GO_TITLE = 'Superhuman Go'
